import { combineReducers } from "redux";
import timesheet from "./timesheet";
import dutyType from "./dutyType";
import unit from "./unit";
import project from "./project";
import product from "./product";
import remark from "./remark";
import subActivity from "./subActivity";
import microActivity from "./microActivity";
import shift from "./shift";
import station from "./station";

export const reducers = combineReducers({
  timesheet,
  dutyType,
  unit,
  project,
  product,
  remark,
  subActivity,
  microActivity,
  shift,
  station,
});
